const require_isFilled = require('./isFilled.cjs');
let imgix_url_builder = require("imgix-url-builder");

//#region src/helpers/asImageSrc.ts
/**
* Returns the URL of an image field with optional image transformations via
* imgix URL parameters.
*
* @example
*
* ```ts
* const src = asImageSrc(document.data.photo, { sat: -100 })
* // => "https://images.prismic.io/repo/image.png?sat=-100"
* ```
*
* @param field - An image field (or one of its responsive views) from which to
*   get an image URL.
* @param config - An object of imgix URL API parameters to transform the image.
*
* @returns The image field's URL with transformations applied, or `null` if the
*   field is empty.
*
* @see Learn how to optimize images with imgix: {@link https://prismic.io/docs/fields/image}
* @see imgix URL parameters reference: {@link https://docs.imgix.com/apis/rendering}
*/
const asImageSrc = (field, config = {}) => {
	if (field && require_isFilled.imageThumbnail(field)) return (0, imgix_url_builder.buildURL)(field.url, config);
	else return null;
};

//#endregion
exports.asImageSrc = asImageSrc;
//# sourceMappingURL=asImageSrc.cjs.map